<div
  class="sidePanelFavourites"
  role="button"
  [attr.aria-label]="isCollapsed ? 'Expand favourites' : 'Collapse favourites'"
  [attr.aria-expanded]="!isCollapsed"
  (click)="toggleCollapsed()"
>
  <div
    class="sidePanelFavourites__inner"
  >
    <pp-icon
      [ppSVG]="
        isCollapsed
          ? iconMap[EIconPath.ICON_NAV_ARROW_RIGHT_18]
          : iconMap[EIconPath.ICON_NAV_ARROW_DOWN_18]
      "
      ppColor="inherit"
      ppClass="setSize16"
    ></pp-icon>

    <span class="sidePanelFavourites__text">
      {{ 'favourites' | ppTranslate }}
    </span>
  </div>

  <div class="sidePanelFavourites__count" aria-label="Favourites count">
    {{ favouritesCount }}
  </div>
</div>
